/// <reference types="node" />

import { getDomainSource, SERVICE } from '@musinsa/packages-device-detection';
import {
  ArrayFormat,
  type AxiosInstance,
  createHttpClient,
  createHttpInstance,
} from '@musinsa/packages-http';
import { getCuratorApiBaseURL } from '../utils/getCuratorApiBaseURL';

/**
 * 파트너 플랫폼(`/v1/partner/*`) 전용 HTTP 인스턴스.
 *
 * 큐레이터(`privateHttpClient`)의 29CM 전용 토큰 리프레시 인터셉터와 분리하기 위해 별도 인스턴스를 사용합니다.
 * 인증은 Next.js middleware(`packages/auth/src/middleware/createAuthMiddleware.ts` + `POAuthStrategy`)에서 처리되므로
 * 클라이언트 사이드 401 리프레시 인터셉터는 설치하지 않습니다 (catalog/partner-catalog 등 기존 파트너 앱과 동일 패턴).
 */
const getPartnerHttpInstance = (): AxiosInstance => {
  const instance = createHttpInstance({
    baseURL: getCuratorApiBaseURL(SERVICE.MUSINSA),
    withCredentials: true,
    // Spring `@RequestParam List<T>` 가 받는 repeat 형식(`brandIds=a&brandIds=b`) 으로 직렬화.
    // axios 기본은 `brandIds[]=a` 라 Spring 이 인식 못함.
    requestParamsOptions: {
      skipNulls: true,
      arrayFormat: ArrayFormat.REPEAT,
    },
  });

  if (typeof window === 'undefined') return instance;

  const service = getDomainSource(window.location.hostname);
  if (service !== SERVICE.UNKNOWN) {
    instance.interceptors.request.use((config) => {
      config.headers['x-platform'] = service;
      return config;
    });
  }

  return instance;
};

export const partnerHttpClient = createHttpClient(getPartnerHttpInstance());
